/**
 * 
 * @param origin 
 * @param radius 
 * @param angle in radians
 * @returns 
 */
export function GetPointOnCircle(origin:Phaser.Geom.Point, radius:number, angleRadians:number, out?: Phaser.Geom.Point): Phaser.Geom.Point
{
    const pt = out ?? new Phaser.Geom.Point();
    pt.setTo(
        origin.x + radius * Math.cos(angleRadians),
        origin.y + radius * Math.sin(angleRadians)
    );
    return pt;
}